import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { StatusPageComponent } from "../common/status-page/status-page.component";

@Component({
  selector: "app-page-not-found",
  standalone: true,
  imports: [StatusPageComponent],
  templateUrl: "./page-not-found.component.html",
  styleUrl: "./page-not-found.component.scss"
})
export class PageNotFoundComponent {
  /** Only offer "Go back" when there is somewhere to go back to (not on a link opened in a new tab). */
  readonly canGoBack = typeof history !== "undefined" && history.length > 1;

  constructor(private router: Router, private location: Location) {
  }

  goToHome() {
    this.router.navigate(["/"]);
  }

  goBack() {
    this.location.back();
  }
}
